import { screeningAction } from '../actions/constant';

export const getAllDisciplineTypeAction = (payload: any) => {
  return {
    type: screeningAction.GET_DISCIPLINE_TYPE_REQUEST,
    payload,
  };
};
